<template>
  <div>
    <b-card class="shadow">
      <div class="col-12">
        <div class="d-flex align-items-center justify-content-between mb-4">
          <h5 class="mb-0 text-gray-800">
            {{ $t("Inscritos e Situações Prioritárias") }}
          </h5>

          <b-button-group>
            <b-button
              variant="outline-dark"
              :class="viewFilterReport === true ? 'active' : ''"
              @click="viewFilters"
            >
              <i class="fas fa-filter"></i>
              {{ $t("Filtros") }}
            </b-button>
          </b-button-group>
        </div>
      </div>

      <div v-if="viewFilterReport" class="col-md-12">
        <form @submit.prevent="submit" ref="addItem">
          <div class="row mb-3">
            <!-- Apenas para gestor -->
            <form-select
              v-if="
                $store.state.user.role_details.name == 'Admin' ||
                $store.state.user.role_details.name == 'Gestor(a)'
              "
              grid="12"
              v-model="item.unidade"
              :itens="unidades"
              :loading="loadingSearchUnidade"
              :disabled="loadingSearchUnidade"
              placeholder="Digite o nome de uma Unidade."
              label="Unidade"
            />
            <!-- Apenas para gestor -->

            <form-select
              v-model="item.sexo"
              label="Sexo"
              grid="4"
              :itens="$root.arrays.beneficio_sexo"
            />

            <form-select
              v-model="item.cor_raca"
              label="Cor/Raça"
              grid="4"
              :itens="$root.arrays.cor_raca"
            />

            <form-select
              v-model="item.genero"
              label="Gênero"
              grid="4"
              :itens="$root.arrays.genero"
            />

            <form-select
              v-if="faixasetarias"
              v-model="item.faixa_etaria"
              label="Faixa Etária"
              grid="12"
              :itens="faixasetarias"
            />

            <form-select
              v-model="item.situacao_prioritaria"
              grid="12"
              label="Situação Prioritária"
              :itens="situacoes_prioritarias"
              :required="true"
              ajuda="Essa situação precisa do parecer técnico e o mesmo deve ser inserido em até 30 dias após a inserção do usuário no serviço."
              :multiple="true"
            />

            <form-calendar
              v-model="data_inicio"
              grid="4"
              label="Data de Início"
            />
            <form-calendar
              v-model="data_fim"
              grid="4"
              label="Data Final"
              :required="verificaDataInicial"
            />

            <form-select
              v-model="item.status"
              grid="4"
              label="Status"
              :itens="$root.arrays.scfv_status_vinculos"
            />
          </div>

          <div class="row pt-4 px-0 d-flex justify-content-end">
            <div class="col-auto px-2 text-right">
              <button
                class="btn btn-default"
                @click.prevent="limparFiltros(), (viewFilterReport = false)"
              >
                <i class="fas fa-times"></i>
              </button>

              <button
                type="button"
                class="btn btn-secondary"
                @click.prevent="limparFiltros()"
              >
                {{ $t("Limpar Filtros") }}
              </button>
              <button
                class="btn btn-success btn-submit"
                data-style="zoom-in"
                type="submit"
              >
                <i class="fas fa-chart-bar"></i>
                {{ $t("Gerar Relatório") }}
              </button>
            </div>
          </div>
        </form>
      </div>
      <loading-report
        :loading="isLoadingMsg"
        mensagem="Por favor aguarde estamos realizando sua solicitação..."
        icone="fa-smile-wink"
      ></loading-report>

      <div class="col-md-12" id="boxPrint">
        <div v-if="isLoading" class="alert alert-info bg-gradient-info">
          Por favor aguarde esse processo pode demorar um pouco...
        </div>
        <div id="headerprint">
          <print-header
            titulo="Relatório de usuários inscritos no SCFV"
            :data_inicial="item.data_inicial"
            :data_final="item.data_final"
          ></print-header>
        </div>
        <div id="reportprint">
          <div id="bodyprint">
            <loading-animation
              :active.sync="loading"
              :is-full-page="false"
              :opacity="1"
              color="#5895FF"
            />
            <b-table
              :fields="[
                {
                  key: 'scfv_grupo',
                  label: $t('Detalhes'),
                },
                {
                  key: 'situacao_prioritaria',
                  label: $t('Situação Prioritária'),
                },
                {
                  key: 'cadastrado',
                  label: $t('Criado em'),
                },
                {
                  key: 'status',
                  label: $t('Status'),
                  class: 'no-print',
                },
              ]"
              :items="resultRelatorio"
              :responsive="true"
              striped
              hover
              show-empty
              small
              outlined
              stacked="sm"
              table-class="mb-3"
            >
              <template v-slot:cell(scfv_grupo)="data">
                <span v-if="data.item.scfv_grupo != null">
                  Grupo:
                  <strong>{{ data.item.scfv_grupo.nome_grupo }}</strong>
                  <br />
                </span>
                Usuário:
                <strong
                  >{{ data.item.usuario.nome_completo }}
                  <b-link
                    :to="'/dashboard/usuario/edit/' + data.item.usuario.id"
                    target="_blank"
                    class="no-print"
                  >
                    <i class="fas fa-external-link-alt"></i> </b-link
                ></strong>
                <br />
                Data de Nascimento:
                <b>{{ data.item.usuario.data_nascimento | formatDate() }}</b>
                <br />
                Cor/Raça:
                <b v-if="data.item.usuario.cor_raca">{{
                  $root.arrays.cor_raca[data.item.usuario.cor_raca - 1].value
                }}</b>
                <br />
                Sexo:
                <b v-if="data.item.usuario.sexo">{{ 
                    $root.arrays.sexo[data.item.usuario.sexo - 1].value 
                }}</b>
                <br />
                Gênero:
                <b v-if="data.item.usuario.genero">{{
                  $root.arrays.genero[data.item.usuario.genero - 1].value
                }}</b>
                <br />
                Idade:
                <b>{{ data.item.usuario.idade_extenso }}</b>
                <br />
                Filiação 1: <b>{{ data.item.usuario.mae }}</b>
              </template>
              <template v-slot:cell(situacao_prioritaria)="data">
                <div v-html="data.item.situacao_prioritaria_nome"></div>
              </template>

              <template v-slot:cell(cadastrado)="data">
                <span v-html="data.value"></span>
              </template>
              <template v-slot:cell(status)="data">
                <span v-html="data.item.status_nome"></span>
              </template>
              <template v-slot:empty="scope">
                <div class="text-center my-5">
                  <img
                    :alt="$t('No results')"
                    class="mb-5"
                    src="/img/icons/robot.svg"
                    style="max-height: 165px"
                  />
                  <h3 class="bold">
                    {{ $t("No records found") }}
                  </h3>
                </div>
              </template>
            </b-table>
          </div>
        </div>

        <div class="row align-items-center no-print">
          <div class="col-lg-6 col-md-12">
            <div class="form-group d-inline-flex mb-0">
              <select
                class="form-control"
                style="width: 70px"
                v-model="item.perPage"
                v-on:change="submit"
              >
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
              </select>
            </div>
            <div class="d-inline-flex ml-2">
              <b-pagination
                :per-page="item.perPage"
                :total-rows="pagination.total"
                @change="changePage"
                v-model="item.page"
              />
            </div>
          </div>
          <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
            <div class="float-lg-right">
              {{ $t("Showing page") }}
              {{ pagination.currentPage }}
              de
              {{ pagination.totalPages }}
              {{ $t("pages in") }}
              {{ pagination.total }}
              {{ $t("records") }}
            </div>
          </div>
        </div>
        <div class="row mt-4 no-print">
          <div class="col-lg-12 col-md-12 text-center align-items-center">
            <b-button
              :title="$t('Visualizar e Imprimir')"
              class="py-2"
              size="sm"
              type="button"
              v-b-tooltip.hover
              variant="primary"
              @click="print()"
            >
              <i class="fas fa-print"></i>
            </b-button>

            <b-button
              :title="$t('Exportar para Excel')"
              @click="exportar"
              class="py-2"
              size="sm"
              type="button"
              v-b-tooltip.hover
              variant="default"
            >
              <i class="fas fa-file-download"></i>
              {{ $t("Exportar para Excel") }}
            </b-button>
          </div>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import { misMixins } from "../../mixins";
export default {
  data() {
    return {
      loading: false,
      loadingSearchUnidade: false,
      loadingStatus: false,
      item: {
        page: 1,
        perPage: 5,
      },
      faixasetarias: [],
      unidades: [],
      resultRelatorio: [],
      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
      isLoading: false,
      isLoadingMsg: false,
      data_inicio: "",
      data_fim: "",
      status: {},
      situacoes_prioritarias: [],
    };
  },
  mixins: [misMixins],
  mounted() {
    this.submit();
    this.getUnidadesExternas();
    this.faixasetarias = this.$root.arrays.scfv_faixa_etaria;
    this.getItensSituacoesPrioritarias();

    if (
      this.faixasetarias[this.faixasetarias.length - 1].value !=
      "Todas as Idades"
    ) {
      this.faixasetarias.push({
        id: this.faixasetarias[this.faixasetarias.length - 1].id + 1,
        value: "Todas as Idades",
      });
    }
  },
  methods: {
    getStatus() {},
    changePage(page) {
      if (
        page > 0 &&
        page <= this.pagination.totalPages &&
        page !== this.item.page
      ) {
        this.item.page = page;
        this.submit();
      }
    },
    submit() {
      if (this.data_inicio) {
        this.item.data_inicial = this.$options.filters.formatDateYMD(
          this.data_inicio
        );
      }
      if (this.data_fim) {
        this.item.data_final = this.$options.filters.formatDateYMD(
          this.data_fim
        );
      }
      this.isLoadingMsg = true;
      this.loading = true;
      axios
        .get("api/dashboard/report/scfv/inscritos", {
          params: this.item,
        })
        .then((response) => {
          this.resultRelatorio = response.data.data;
          this.pagination = response.data.pagination;

          if (this.pagination.totalPages < this.pagination.currentPage) {
            this.item.page = this.pagination.totalPages;
            this.submit();
          } else {
            this.loading = false;
            this.isLoadingMsg = false;
          }

          if (response.data.data.length == 0) {
            this.result = false;
          } else {
            this.result = true;
          }
        })
        .catch(() => {
          this.loading = false;
          this.isLoadingMsg = false;
          this.result = false;
        })
        .finally(() => {
          this.loading = false;
          this.isLoadingMsg = false;
        });
    },
    exportar() {
      this.isLoading = true;
      this.item.exportInscritos = "ok";
      swal.fire({
        title: "Aguarde",
        text: "O Arquivo está sendo gerado.",
        imageUrl: `${window.urlbase}img/load.gif`,
        showConfirmButton: false,
      });
      axios
        .get("api/dashboard/report/scfv/inscritos", {
          params: this.item,
        })
        .then((response) => {
          swal.fire({
            title: "Arquivo Pronto para Download!",
            html: `<a href="${response.data.link}" target="_blank">Clique aqui para baixar</a>`,
            icon: "success",
            showConfirmButton: false,
          });
        })
        .finally(() => (this.isLoading = false));
    },
    limparFiltros() {
      this.item = {};
      this.data_inicio = "";
      this.data_fim = "";
      this.verificaDataInicial = false;
    },
    getItensSituacoesPrioritarias() {
      axios
      .get(`api/dashboard/situacoes_prioritarias`)
      .then((response) => {
        this.situacoes_prioritarias = response.data.map((elem) => ({
          id: elem.id,
          value: elem.descricao,
        }));
      })
    },
  },
};
</script>
